import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Sorting = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M28.427 5.347h-12.6a1.07 1.07 0 0 0-1.067 1.066c0 .587.48 1.067 1.067 1.067h12.6a1.07 1.07 0 0 0 1.066-1.067 1.07 1.07 0 0 0-1.066-1.066ZM25.12 10.467h-9.28a1.07 1.07 0 0 0-1.067 1.066c0 .587.48 1.067 1.067 1.067h9.28a1.07 1.07 0 0 0 1.067-1.067 1.07 1.07 0 0 0-1.067-1.066ZM22.213 15.507H15.84a1.07 1.07 0 0 0-1.067 1.066c0 .587.48 1.067 1.067 1.067h6.373a1.07 1.07 0 0 0 1.067-1.067 1.07 1.07 0 0 0-1.067-1.066ZM13.427 20.547 10.4 23.213v-16.8a1.07 1.07 0 0 0-1.067-1.066 1.07 1.07 0 0 0-1.066 1.066v16.8L5.24 20.547a1.072 1.072 0 0 0-1.507.093c-.386.44-.346 1.12.094 1.507l4.786 4.226c.08.067.16.12.267.174h.027a1.1 1.1 0 0 0 .413.093c.147 0 .28-.04.413-.093h.027c.093-.04.187-.107.267-.174l4.8-4.226c.44-.387.48-1.067.093-1.507a1.072 1.072 0 0 0-1.507-.093h.014Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Sorting
